import { render, staticRenderFns } from "./OperaCompanyChangeIngWindow.vue?vue&type=template&id=21ad5e56&scoped=true&"
import script from "./OperaCompanyChangeIngWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCompanyChangeIngWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCompanyChangeIngWindow.vue?vue&type=style&index=0&id=21ad5e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad5e56",
  null
  
)

export default component.exports